module.exports = __webpack_public_path__ + "img/bostie_and_leash.8dee407a.svg";